import React from 'react';
import { HVAHealthCareProvider } from './HVAHealthCareContext';
import HVAHealthCarePage from './HVAHealthCarePage';
import { HVAHealthCarePageProps } from './types';

/**
 * Container component for the healthcare appointment system.
 * Wraps the page content with the context provider.
 */
const HVAHealthCareContainer: React.FC<HVAHealthCarePageProps> = props => {
  return (
    <HVAHealthCareProvider>
      <HVAHealthCarePage {...props} />
    </HVAHealthCareProvider>
  );
};

export default HVAHealthCareContainer;
